import React, { Component } from 'react';
import { connect } from "react-redux";




@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class TextForm extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-form-container">
                    <div className="label-wrapper">
                        <label>{this.props.labelname}</label>
                    </div>
                    <div>
                        <input type="text" className="form-control" onChange={evt => this.props.setValue(evt,this.props.index)} value={this.props.defaultv}/>
                        {this.props.error===true &&
                            <span className="field-error">Field cannot be empty</span>
                        }
                    </div>

                </div>
            </React.Fragment>
        );
    }
}

export default TextForm;
